function AgentsControls() {
    "use strict";

    this.CardView = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;
    this.Validator = null;

    // Escalation Plans
    this.EscalationPlanListView = null;

    // Profile
    this.ProfileListView = null;

    // Caseload
    this.CurrentCaseloadListView = null;
    this.CurrentCaseloadListViewFilter = null;
    this.CurrentCaseloadAdditionalListView = null;
    this.CurrentCaseloadAddAdditionalListView = null;

    // My Zones
    this.MyZonesListView = null;
    this.MyZonesListViewFilter = null;

    // Daily Notifications
    this.DailyNotificationsListView = null;
    this.DailyNotificationsEventsListView = null;
    this.DailyNotificationsScopeListView = null;

    // Immediate Notifications
    this.ImmediateNotificationsListView = null;
    this.ImmediateNotificationsEventsListView = null;
    this.ImmediateNotificationsRiskLevelListView = null;
    this.ImmediateNotificationsScopeListView = null;
    this.ImmediateNotificationsMethodListView = null;
    this.ImmediateNotificationsFormatListViewList = [];
    this.ImmediateNotificationsTimeListView = null;

    // Risk Level Plans
    this.RiskLevelListView = null;

    // Off Hours
    this.OffHoursListView = null;
    this.OffHoursValidator = null;

    this.PasswordValidator = null;
    this.userPermissionsChanged = [];

    // caseload zones+schedules
    this.ZonesCaseloadListView = [];
    this.ScheduleCaseloadListView = [];
}
if (typeof exports !== 'undefined') {
    module.exports = AgentsControls;
}